export default "__VITE_ASSET__41025c95__"